import { formatTableData, getData } from '../utils/formatters';

// Define the type for La Quinta GIS data based on the deserializer
interface LaQuintaData {
  address?: string;
  unit?: string;
  city?: string;
  zip?: string;
  lot?: string;
  parcelId?: string;
  ownerName?: string;
  ownerStreetAddress?: string;
  ownerCity?: string;
  ownerState?: string;
  ownerZip?: string;
  subdivisionName?: string;
  schoolDistrict?: string;
  taxDistrict?: string;
  neighborhood?: string;
  localDistrict?: string;
  stateDistrict?: string;
  districtName?: string;
  acres?: number;
  deedType?: string;
  zoningCode?: string;
  mapLink?: string;
  propertyCardLink?: string;
  taxBillLink?: string;
  imageLink?: string;
}

const LA_QUINTA_ROWS = [
  {
    label: 'Address',
    getValue: (data: LaQuintaData) => getData(data, 'address', 'No address available')
  },
  {
    label: 'Zone',
    getValue: (data: LaQuintaData) => getData(data, 'zoningCode', 'No unit available')
  },

  {
    label: 'Unit',
    getValue: (data: LaQuintaData) => getData(data, 'unit', 'No unit available')
  },
  {
    label: 'City, Zip',
    getValue: (data: LaQuintaData) => `${getData(data, 'city', 'N/A')}, ${getData(data, 'zip', 'N/A')}`
  },
  {
    label: 'Subdivision',
    getValue: (data: LaQuintaData) => getData(data, 'subdivisionName', 'No subdivision information available')
  },
  {
    label: 'Tax District',
    getValue: (data: LaQuintaData) => getData(data, 'taxDistrict', 'No tax district available')
  },
  {
    label: 'Parcel ID',
    getValue: (data: LaQuintaData) => getData(data, 'parcelId', 'No parcel ID available')
  },
  {
    label: 'Property Size',
    getValue: (data: LaQuintaData) => {
      const acres = getData(data, 'acres', null);
      return acres ? `${acres} acres` : 'No property size information available';
    }
  },
  {
    label: 'Deed Type',
    getValue: (data: LaQuintaData) => getData(data, 'deedType', 'No deed type available')
  },
];

export const formatLaQuintaData = (data: LaQuintaData): string => {
  return formatTableData(data, LA_QUINTA_ROWS);
};
